<template>
  <div class="promo-integration-content-wrapper">
    <div :class="['promo-integration-modal-wrapper', `tabs-content-editing-${isEditing}`]">
      <div
        v-for="(item, index) in thirdPartyOptions"
        v-show="item.provider === currentTab"
        :key="index"
        :class="[`promo-integration-tab-content editing-${isEditing}`]"
      >
        <div v-if="selectedIntegration && isEditing">
          <div class="promoint-slctd-name">
            <span class="slctd-int-provider">{{
              StringUtils.titleize(selectedIntegration.provider)
            }}</span>
            <v-icon start end>md:chevron_right</v-icon>
            {{ selectedIntegration.description }}
          </div>
        </div>
        <v-card-text v-else>
          <v-radio-group
            v-model="selectedIntegration"
            hideDetails
            class="thirdparty-radio"
            style="margin-top: 10px; padding-top: 0"
          >
            <div
              v-for="(action, index) in item.value.actions"
              :key="index"
              class="thirdparty-radio-item"
            >
              <v-radio
                v-if="!action.disabled"
                :label="action.description"
                :value="action"
                :disabled="action.disabled"
              ></v-radio>
              <div v-else class="thirdparty-input-error-div">
                <v-icon color="#cccccc">md:radio_button_unchecked</v-icon>
                <div>
                  <div>{{ action.description }}</div>
                  <div class="thirdparty-input-error">
                    <v-icon size="16" start color="warning">md:warning</v-icon>Requirements not met.
                  </div>
                </div>
              </div>
            </div>
          </v-radio-group>
        </v-card-text>
        <div class="promo-intergration-tab-next-value">
          <div
            v-for="(input, index) in selectedIntegration.inputs"
            :key="'input' + index"
            class="promo-add-integration-thirdparty-value"
          >
            <v-text-field
              v-if="input.type === 'text_input'"
              v-model="integrationValue[input.valueDescription]"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              :label="input.valueLabel"
              required
              :placeholder="input.placeholder"
            ></v-text-field>
            <v-text-field
              v-if="input.type === 'number_input'"
              v-model="integrationValue[input.valueDescription]"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              :label="input.valueLabel"
              :placeholder="input.placeholder"
              type="number"
              required
            />
            <v-autocomplete
              v-if="input.type === 'select'"
              v-model="integrationValue[input.valueDescription]"
              variant="outlined"
              hideDetails
              density="compact"
              required
              :label="input.valueLabel"
              :items="dropdownOptions(input.values)"
              itemTitle="text"
            ></v-autocomplete>
            <v-textarea
              v-if="input.type === 'text_field'"
              v-model="integrationValue[input.valueDescription]"
              variant="outlined"
              hideDetails
              density="compact"
              required
              rows="3"
              :label="input.valueLabel"
            ></v-textarea>
            <div v-if="input.type === 'json'">
              <p>{{ input.valueLabel }}</p>
              <component
                :is="codeEditor.CodeEditor"
                v-model="integrationValue[input.valueDescription]"
                v-bind="codeEditor.props"
                :languages="codeEditor.languages('json')"
              ></component>
            </div>
            <p v-if="input.counter && integrationValue[input.valueDescription]">
              Character Count: {{ integrationValue[input.valueDescription].length }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="promo-add-integration-buttons" style="padding-top: 1rem; text-align: right">
      <v-btn
        size="large"
        style="margin-right: 1rem"
        variant="outlined"
        class="promo-add-integration cancel-btn"
        @click="close"
        >Cancel</v-btn
      >
      <v-btn
        size="large"
        variant="flat"
        color="success"
        :disabled="!submitEnabled"
        class="promo-add-integration"
        style="width: 200px"
        @click="submitAdd(integrationValue, selectedIntegration)"
      >
        <v-icon start>md:add</v-icon>
        {{ buttonCTA }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { useCodeEditor } from "@/utils/composables/useCodeEditor";
import StringUtils from "@/utils/StringUtils";

export default {
  name: "RfRetentionConnectorThirdParties",
  props: [
    "model",
    "editIntegration",
    "editIntegrationValue",
    "isEditing",
    "thirdPartyOptions",
    "currentTab",
  ],
  setup: () => ({ codeEditor: useCodeEditor(), StringUtils }),
  data() {
    return {
      selectedIntegration: this.editIntegration,
      integrationValue: this.editIntegrationValue,
    };
  },
  computed: {
    buttonCTA() {
      if (this.isEditing) {
        return "Update Action";
      }
      return "Add Action";
    },
    submitEnabled() {
      if (this.selectedIntegration.inputs) {
        const blankValue = this.selectedIntegration.inputs.find(
          input => !this.integrationValue[input.valueDescription] && input.isRequired,
        );
        return !blankValue;
      }
      return false;
    },
  },
  watch: {
    integrationValue(to) {
      this.$emit("integrationValue", to);
    },
    selectedIntegration(to) {
      this.$emit("selectedIntegration", to);

      if (to.inputs) {
        const inputsWithDefaults = to.inputs.filter(input => input.defaultValue);
        inputsWithDefaults.forEach(
          input => (this.integrationValue[input.valueDescription] = input.defaultValue),
        );
      }
    },
  },
  methods: {
    close() {
      this.resetSelectedIntegration();
      this.$emit("closeConnectorDialog");
    },
    resetSelectedIntegration() {
      this.integrationValue = {};
      this.selectedIntegration = {};
    },
    submitAdd(value, integration) {
      this.$emit("addIntegration", value, integration);
      this.resetSelectedIntegration();
    },
    dropdownOptions(options) {
      if (!options || !options.map) return [];
      return options.map(option => {
        if (typeof option === "object") {
          return {
            text: option.name,
            value: option.id,
          };
        }
        return option;
      });
    },
  },
};
</script>
